import { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import { request } from '../functions/apiRequestWrapper';
import Breadcrumb from '../components/Breadcrumb';
import Banner from '../components/Banner';
import Loader from '../components/Loader';
import Accordion from 'react-bootstrap/Accordion';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionButton } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import _findIndex from 'lodash/findIndex';
import _find from 'lodash/find';
import { PATH_HELP } from '../constants';

import { connect } from 'react-redux';
import { logout } from '../redux/User';
const mapDispatchToProps = dispatch => {
    return {
        logout: () => { dispatch(logout()); }
    }
}

const ContextAwareCard = ({ eventKey, callback, question, answer }) => {
    const { activeEventKey } = useContext(AccordionContext);
    const decoratedOnClick = useAccordionButton(
        eventKey,
        () => callback && callback(eventKey),
    );
    return (
        <Card className={cn({"active": activeEventKey === eventKey})}>
            <Card.Header><button type="button" onClick={decoratedOnClick}>{question}</button></Card.Header>
            <Accordion.Collapse eventKey={eventKey}>
                <Card.Body>
                    <div dangerouslySetInnerHTML={{__html: answer}} />
                </Card.Body>
            </Accordion.Collapse>
        </Card>
    );
}

const Help = ({ logout, match, history }) => {

    const [page, setPage] = useState({title: "Help"});
    const [categories, setCategories] = useState([]);
    const [questions, setQuestions] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setTimeout(() => {window.scrollTo(0, 0);}, 100);
        request(
            `${process.env.REACT_APP_API}/1/cms/contentpage/help`
        ).then((pageData) => {
            // console.log(data);
            setPage(pageData);
            //
            request(
                `${process.env.REACT_APP_API}/1/cms/faqs`
            ).then((faqData) => {
                // console.log(data);
                // filter empty categories
                let cats = [];
                if (faqData.categories?.length > 0 && faqData.questions) {
                    for (let i=0; i<faqData.categories.length; i++) {
                        let cat = faqData.categories[i];
                        let idx = _findIndex(faqData.questions, {category: cat.label});
                        if (idx > -1) {
                            cats.push(cat);
                        }
                    }
                }
                setCategories(cats);
                setQuestions(faqData.questions);
                setIsLoading(false);
            }).catch((error) => {
                if (error.status === 401) {
                    logout();
                } else {
                    console.error(error);
                    let msg = "An error has occured";
                    if (error.body?.message) {
                        msg = error.body.message;
                    }
                    setError(msg);
                    setIsLoading(false);
                }
            });
            //
        }).catch((error) => {
            if (error.status === 401) {
                logout();
            } else {
                console.error(error);
                let msg = "An error has occured";
                if (error.body?.message) {
                    msg = error.body.message;
                }
                setError(msg)
                setIsLoading(false);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (match.params.category && _findIndex(categories, {slug: match.params.category}) === -1) {
            history.replace(PATH_HELP);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categories, match.params]);

    const activeCategorySlug = match.params.category;
    let activeCategoryLabel = null;
    if (activeCategorySlug && categories.length > 1) {
        let activeCategory = _find(categories, {slug: activeCategorySlug}) || {};
        activeCategoryLabel = activeCategory.label
    }
    
    return (
        <div className="page help container px-3 px-md-5 pb-5">
            <Breadcrumb>Help</Breadcrumb>
            <Banner imageUrl={page?.imageUrl ? page.imageUrl : false}><h1><b>{page.title}</b></h1></Banner>
            {page?.bodyContent && <div dangerouslySetInnerHTML={{__html: page.bodyContent}} className="mb-5" />}

            {error && <p>{error}</p>}

            {categories?.length > 1 &&
                <div className="faq-categories mb-5 mx-md-5">
                    <Button key={`all`}
                        as={Link}
                        to={`${PATH_HELP}`}
                        variant={(activeCategorySlug === undefined || activeCategorySlug === null) ? "primary" : "outline-primary"}
                        className="me-3">
                        All
                    </Button>

                    {categories.map((cat, i) => {
                        return (
                            <Button key={`catlink${i}`}
                                as={Link}
                                to={`${PATH_HELP}/${cat.slug}`}
                                variant={activeCategorySlug === cat.slug ? "primary" : "outline-primary"}
                                className="me-3">
                                    {cat.label}
                            </Button>
                        );
                    })}
                </div>
            }

            {questions && <Accordion className="faq mb-5 mx-md-5">
                {questions.map((q, index) => {
                    if (activeCategoryLabel === null || q.category === activeCategoryLabel) {
                        return (
                            <ContextAwareCard key={`q_${q.id}`} eventKey={`${q.id}`} question={q.question} answer={q.answer} />
                        );
                    }
                    return null;
                })}
            </Accordion>}

            {isLoading && <Loader type="placeholder" />}
        </div>
    );
}

const routerHelp = withRouter(Help);
export default connect(undefined, mapDispatchToProps)(routerHelp);
